module.exports = __webpack_public_path__ + "img/retail_advantage_bg_img01.09f352db.png";